import { Icon } from '@dixa/lib-shared-habla';
import { useSortable } from '@dnd-kit/sortable';
import { addNewBlockBelow, MenuOption } from 'articleEditor/utils/actions';
import cx from 'classnames';
import { findNodePath } from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyRootBlock } from 'lib-knowledge-document-structure/plateTypes';

import s from './block.module.scss';
import { BlockMenu } from './blockMenu';

type Props = {
  element: MyRootBlock;
  blockActions: ReadonlyArray<MenuOption>;
  setShowingMenu: (newShow: boolean) => void;
  selectedActionIndex?: number;
  showingMenu: boolean;
  sortable: ReturnType<typeof useSortable>;
};

export function BlockActions({
  showingMenu,
  setShowingMenu,
  selectedActionIndex,
  sortable,
  blockActions,
  element,
}: Props): JSX.Element {
  const editor = useMyEditorRef();
  const path = findNodePath(editor, element);
  if (!path)
    throw new Error(`Path not found for element: ${JSON.stringify(element)}`);

  return (
    <div
      contentEditable={false}
      className={cx(s['blockActions'], showingMenu && s['blockShowingMenu'])}
    >
      <button
        onClick={(clickEvent) => {
          addNewBlockBelow({
            editor,
            element,
            path,
            selection: editor.selection,
            anchorElement: clickEvent.currentTarget,
          });
        }}
        className={cx(s['blockButton'], s['blockButtonAdd'])}
        tabIndex={-1}
      >
        <Icon className={s['blockIcon']} name="plus" size={20} />
      </button>

      <BlockMenu
        editor={editor}
        element={element}
        path={path}
        blockActions={blockActions}
        selectedActionIndex={selectedActionIndex}
        sortable={sortable}
        showingMenu={showingMenu}
        setShowingMenu={setShowingMenu}
      />
    </div>
  );
}
